import React from 'react';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import Popup from '../../components/ConformationPopup/Popup';
import SideNavBar from '../../components/SideNavBar/SideNavBar';
import { deleteOfferletterData, getOfferletterData } from '../../service/adminApi';
import { getTimestampToDate } from '../../utils/dateConvetor';
import Loader from '../../StaticComponent/Loader';
import './card-structure.css';
import { getS3 } from '../../utils/Download';

function OfferLetter() {
    let breadCrumbsData = [
        { title: 'Dashboard', isActive: true, path: '/Overview' },
        { title: 'Admin', isActive: true, path: '/admin/accountbranding' },
        { title: 'Recruitment Settings', isActive: true, path: 'admin/recuritementmessage' },
        { title: 'OfferLetter', isActive: false, path: '' },
    ];

    const [OfferLetterList, setOfferLetterList] = React.useState([]);
    const [deleteIndex, setDeleteIndex] = React.useState();
    const [editData, setEditData] = React.useState();
    const [hideContainer, setHideContainer] = React.useState(true);
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        getOfferLetter();
    }, []);

    const getOfferLetter = async () => {
        const response = await getOfferletterData();
        setLoading(true);
        setOfferLetterList(response.data.data);
    };

    const updateOfferLetterDetails = (data) => {
        switch (data) {
            case 'cancel':
                setEditData({});
                break;
            case 'update':
                getOfferLetter();
                break;
            default:
                break;
        }
    };

    const renderOfferLetter = () => {
        if (OfferLetterList.length > 0) {
            return OfferLetterList.map((offerLetter) => {
                let date = getTimestampToDate(offerLetter.modified_at, 3);
                return (
                    <div className="col-md-3 mt-4 mb-3">
                        <div className="card m-2 admin-card-styles border-0">
                            <a  style={{cursor:"pointer"}} onClick={async () => {

window.open(await getS3(offerLetter.attachment_url), "_blank");


}} className="card m-2 admin-card-styles border-0" target="_blank">
                                <img src="/Images/offer-letter.png" className="hive-table-sort" alt="Document-image" />
                            </a>
                            <div className="card-body hive-profile-footer-bg">
                                <div className="d-flex justify-content-between">
                                    <h5 className="card-title bold-text font-16">{offerLetter.title}</h5>
                                    <div>
                                        <button
                                            type="button "
                                            className="btn p-0 align-top shadow-none"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            <img src="/Images/kebab-menu.svg" />
                                        </button>
                                        <ul className="dropdown-menu dropdown-menu-end border-0 shadow-sm hive-kebab-dropdown">
                                            <li>
                                                <a
                                                    className="dropdown-item dditems semibold-text font-12 border-bottom touchbase-kebabitems-color"
                                                    data-bs-toggle="offcanvas"
                                                    data-bs-target="#offcanvasRight"
                                                    aria-controls="offcanvasRight"
                                                    onClick={() => {
                                                        setEditData(offerLetter);
                                                        setHideContainer(false);
                                                    }}
                                                >
                                                    Edit
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#logout"
                                                    className="dropdown-item dditems semibold-text font-12 touchbase-kebabitems-color"
                                                    onClick={() => {
                                                        setDeleteIndex(offerLetter.id);
                                                    }}
                                                >
                                                    Delete
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <p className="card-text regular-text font-12 hive-card-desc-labelcolor">Last Updated on {date}</p>
                            </div>
                        </div>
                    </div>
                );
            });
        } else {
            return (
                <div className="row justify-content-center  w-100">
                    <img src="/Images/nodatafound.png" alt="no-records" style={{ width: 700, height: 500 }} />
                    <span className="row justify-content-center tt-bold font-16">No Offer Letter</span>
                </div>
            );
        }
    };

    const deleteOfferLetter = async () => {
        let data = {
            id: deleteIndex,
        };
        const response = await deleteOfferletterData(data);
        if (response.data.statusCode === 200) {
            getOfferLetter();
        }
    };

    return (
        <div>
            <div className="col-md-10 offset-md-2 content-card">
                {hideContainer == false ? (
                    <SideNavBar
                        handleData={(data) => {
                            updateOfferLetterDetails(data);
                        }}
                        editData={editData}
                        form="offerletter"
                        hideContainer={hideContainer}
                        setHideContainer={() => setHideContainer()}
                    />
                ) : null}
                <BreadCrumbs data={breadCrumbsData} />
                <div className="row mb-5">
                    <div className="col-md-12">
                        <div className="d-flex justify-content-between mt-2">
                            <h5 className="bold-text tt-bold font-18">Offer Letter</h5>
                            <a
                                className="btn hive-btn-primary"
                                type="button"
                                onClick={() => setHideContainer(false)}
                                // data-bs-toggle="offcanvas"
                                // data-bs-target="#offcanvasRight"
                                // aria-controls="offcanvasRight"
                            >
                                <img className="me-2" src="/Images/plus.svg" />
                                New Offer Letter
                            </a>
                        </div>
                    </div>
                    {renderOfferLetter()}
                </div>
            </div>
            <Popup
                deleteData={() => {
                    deleteOfferLetter();
                }}
            />
            <Loader isLoading={loading} />
        </div>
    );
}

export default OfferLetter;
